import { FormikProps } from 'formik';
import React from 'react';
import { FormField } from '../../../../../global/components/form-element/form-field';
import { DividerSection } from '../../../../../global/components/layout/divider-section';
import { FormGroup } from '../../../../../global/components/layout/form-group';
import { ContentSpacer } from '../../../../../global/components/layout/generic-content-spacer';
import { getFormattedDate } from '../../../../../global/helpers/date-helpers';
import { DomesticPartnerWizard } from '../wizard/domestic-partner-wizard';


interface Props {
    formProps: FormikProps<any>;
    wizard: DomesticPartnerWizard;
}
export function DomesticPartnerDeathFields(props: Props) {
    const {
        formProps,
        wizard,
    } = props;

    const relationshipsProps = wizard?.getRelationShipSettings();
    return (
        <DividerSection sectionText={relationshipsProps?.deathDomesticPartnerTitle} removeDivider >
            <FormGroup>
                <ContentSpacer>

                    <FormField
                        name='date_of_death'
                        label={relationshipsProps?.widowedPreliminaryDateDeathLabel}
                        component='datePicker'
                        touched={formProps.touched}
                        errors={formProps.errors}
                        required
                        autoWidth
                    />
                </ContentSpacer>
                <ContentSpacer>
                    <>
                        <p><strong>{relationshipsProps?.relationshipStartDateLabel}</strong></p>
                        <p>{getFormattedDate(formProps.values?.start_date)}</p>
                    </>
                </ContentSpacer>
            </FormGroup>
        </DividerSection>
    );
}